import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilterTimeline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFilterTimeline"><Path d="M7.00175 4V16.5849L8.99977 14.5858L10.4144 15.9996L6.00213 20.4142L1.58594 16.0004L2.99977 14.5858L5.00175 16.5867V4H7.00175Z" fill="currentColor"/><Path d="M11 6V8H21V6H11Z" fill="currentColor"/><Path d="M15 16V18H21V16H15Z" fill="currentColor"/><Path d="M13 11H21V13H13V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilterTimeline;
